import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary, ButtonSecondary } from '@spotify-internal/encore-web';

import { useT } from 'client/i18n/hooks/useT';

export function SwitchModal({
  dismissSwitchModal,
}: {
  dismissSwitchModal?: () => void;
}) {
  const t = useT();

  // TODO https://anchorfm.atlassian.net/browse/CAST-2750: Update to final text and translate
  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={dismissSwitchModal}
      aria-labelledby="integration-connection-switch-modal"
    >
      <Modal.Title id="integration-connection-switch-modal">
        {t(
          'IntegrationConnectionScreen.SwitchModal.Title',
          'Switching your podcast to Anchor',
          'The title for the switch modal in the integration connection flow'
        )}
      </Modal.Title>
      <Modal.Body>
        {t(
          'IntegrationConnectionScreen.SwitchModal.Body',
          'Switching is easy, just provide your RSS feed and create an Anchor account. After you switch, you’ll need to go back to Riverside.fm to import your file.',
          'The body for the switch modal in the integration connection flow'
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonSecondary onClick={dismissSwitchModal}>
          {t(
            'IntegrationConnectionScreen.SwitchModal.DismissAction',
            'Nevermind',
            'The action for the switch modal in the integration connection flow when user decides against importing to Anchor'
          )}
        </ButtonSecondary>
        <ButtonPrimary as="a" href="/switch">
          {t(
            'IntegrationConnectionScreen.SwitchModal.ContinueAction',
            'Switch',
            'The action for the switch modal in the integration connection flow when user decides to continue importing to Anchor'
          )}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
}
